import React from 'react';
import './CountButton.scss';

const CountButton = ({ value, setValue, min, max, step }) => {

    const handleValue = (val) => {
        if( typeof step === 'undefined'){
            if( val === -1 && value === min ) return;
            else if( val === 1 && value === max ) return;

            setValue(value + val)
        }else {
            if( val === -1 && value === min ) return;
            else if( val === 1 && value === max ) return;

            setValue(value + step*val)
        }
    }

    return (
        <div className='count-btn'>
            <p className={`icon ${value === min ? 'disable' : ''}`} onClick={() => handleValue(-1)}>
                {
                    value === min ?
                    <img src={require('../../aseets/icons/minus_gray.svg').default} style={{ width : 24, height : 24 }} />
                    :
                    <img src={require('../../aseets/icons/minus_pink.svg').default} style={{ width : 24, height : 24 }} />
                }
            </p>
            <p className='value'>{value}</p>
            <p className={`icon ${value === max ? 'disable' : ''}`} onClick={() => handleValue(1)}>
                {
                    value === max ?
                    <img src={require('../../aseets/icons/plus_gray.svg').default} style={{ width : 24, height : 24 }} />
                    :
                    <img src={require('../../aseets/icons/plus_pink.svg').default} style={{ width : 24, height : 24 }} />
                }
            </p>
        </div>
    )
}

export default CountButton;